import { useState } from "react";

const Links = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Informações do WhatsApp
  const telefoneWhatsApp = "5517981990892";
  const mensagemAgendar = "Olá, gostaria de agendar uma consulta na clínica Dra. Mayle Coelho.";
  const mensagemDuvidas = "Olá, tenho algumas dúvidas sobre os tratamentos.";

  // Endereço
  const endereco = "Centro Empresarial Total Office, Rua João Teixeira, 148 - Vila Santa Cruz Sala 18";
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(endereco)}`;
  const wazeUrl = `https://waze.com/ul?q=${encodeURIComponent(endereco)}`;

  return (
    <div className="flex flex-col">
      <div className="flex justify-center flex-grow">
        <div className="w-72 flex-col flex justify-center gap-6 font-raleway text-base">
          {/* Botão Agendar Consulta */}
          <a
            href={`https://wa.me/${telefoneWhatsApp}?text=${encodeURIComponent(mensagemAgendar)}`}
            className="bg-gradient-to-br from-[#7c736a] via-[#968c83] to-[#7c736a] py-2 px-4 shadow-md hover:scale-105 transition-transform duration-300 text-center rounded-xl cursor-pointer z-10 text-white"
            target="_blank"
            rel="noreferrer"
          >
            Agendar minha consulta
          </a>

          {/* Botão de Localização */}
          <button
            onClick={() => setIsModalOpen(true)}
            className="bg-gradient-to-br from-[#7c736a] via-[#968c83] to-[#7c736a] py-2 px-4 shadow-md hover:scale-105 transition-transform duration-300 text-center rounded-xl cursor-pointer z-10 text-white"
          >
            Localização
          </button>

          {/* Botão Dúvidas */}
          <a
            href={`https://wa.me/${telefoneWhatsApp}?text=${encodeURIComponent(mensagemDuvidas)}`}
            className="bg-gradient-to-br from-[#7c736a] via-[#968c83] to-[#7c736a] py-2 px-4 shadow-md hover:scale-105 transition-transform duration-300 text-center rounded-xl cursor-pointer z-10 text-white"
            target="_blank"
            rel="noreferrer"
          >
            Dúvidas
          </a>
        </div>
      </div>

      <footer className="flex justify-center pb-6 pt-12">
        <img src="./LogoFooter.png" alt="Logo do Rodapé" className="w-64 z-10" />
      </footer>

      {/* Modal de Localização */}
      {isModalOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50"
          onClick={(e) => e.target === e.currentTarget && setIsModalOpen(false)}
        >
          <div className="bg-gradient-to-br from-[#fcf9f7] via-[#f8efe8] to-[#fcf9f7] p-6 rounded-lg shadow-lg w-[90%] max-w-md z-50">
            <h2 className="text-xl font-semibold text-center mb-1">Nossa Localização</h2>
            <p className="text-center text-gray-600 mb-2">
              Centro Empresarial Total Office <br />
              Rua João Teixeira, 148 - Vila Santa Cruz <br />
              <span className="font-bold">Sala 18 - Primeiro andar</span>
            </p>
            <div className="mt-1 flex justify-center">
              {/* Google Maps Embed */}
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d233.0878060501179!2d-49.37453891957371!3d-20.81535016025141!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s!5e0!3m2!1spt-BR!2sbr!4v1741451363082!5m2!1spt-BR!2sbr"
                title="Maps"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            {/* Botões Google Maps e Waze */}
            <div className="mt-4 flex flex-col gap-3">
              <a
                href={googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-gradient-to-br from-[#7c736a] via-[#b1a69d] to-[#7c736a] text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-800 transition"
              >
                <img src="./Maps.png" alt="Google Maps" className="w-8 h-8" />
                Abrir no Google Maps
              </a>

              <a
                href={wazeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-gradient-to-br from-[#7c736a] via-[#b1a69d] to-[#7c736a] text-white py-2 px-4 rounded-lg shadow-md hover:bg-blue-700 transition"
              >
                <img src="./Waze.png" alt="Waze" className="w-8 h-8" />
                Abrir no Waze
              </a>
            </div>

            {/* Botão Fechar */}
            <div className="mt-4 flex justify-center">
              <button
                onClick={() => setIsModalOpen(false)}
                className="px-4 py-2 bg-gradient-to-br from-[#7c736a] via-[#b1a69d] to-[#7c736a] text-white rounded-lg hover:bg-gray-900"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Links;
